export class BucketService {
    static $inject = ['MessagingHubService'];
    constructor(MessagingHubService) {
        this.MessagingHubService = MessagingHubService;
    }
    async set(bucket, resource, type = 'application/json', expiration) {
        let uri = `/buckets/${encodeURIComponent(bucket)}`;
        if (expiration) {
            uri = `${uri}?expiration=${expiration}`;
        }
        return await this.MessagingHubService.sendCommand({
            method: 'set',
            type: type,
            uri: uri,
            resource,
        });
    }
    async get(bucket, take = 100) {
        return await this.MessagingHubService.sendCommand({
            method: 'get',
            uri: `/buckets/${bucket}?$take=${take}`,
        });
    }
    async delete(bucket) {
        return await this.MessagingHubService.sendCommand({
            method: 'delete',
            uri: `/buckets/${bucket}`,
        });
    }
}
BucketService.$inject = ['MessagingHubService'];
